module.exports = __webpack_public_path__ + "static/media/cammino_4.6d8ed275.jpg";